<template>
    <b-row class="marketing-plan-item">
        <b-col lg="4" cols="9" class="marketing-plan-item--label">
            <p>{{ label }}</p>
        </b-col>
        <b-col lg="4" cols="3" class="marketing-plan-item--button">
            <a :href="link"
               target="_blank"
               class="button--primary"><span class="desktop-only">Download</span><i class="fa fa-download mobile-only" aria-hidden="true"></i></a>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        props: ['label', 'link']
    }
</script>

<style lang="scss" scoped>
    .marketing-plan-item{
        display: flex;
        align-items: center;
        margin: 0 0 14px;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/marketing-plan/MarketingPlanItem.vue